import { Box, CircularProgress, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./VideoSuiteHistoryStyle.css";
import VideoSuiteHistoryDetailsModal from "../Components/VideoSuiteHistoryDetailsModal";
import VideoSuiteHistoryCard from "../Components/VideoSuiteHistoryCard";
import { VideoHistoryData } from "../../../../Types/VideoSuite-Types";
import EmptySuiteHistory from "../Components/EmptySuiteHistory";
import { useGetVideoSuiteHistory } from "../../../../store/Apis/SuitesApps/VideoSuiteHistoryApi";
import { useOutletContext } from "react-router-dom";
import { useGetUserCredits } from "../../../../store/Apis/StripeApi";
interface ContextType {
  VideoAppHistoryItems: VideoHistoryData[];
  DeleteVideoItem: (itemId: String) => void;
  isVideoHistoryLoading: boolean;
  isDeleteVideoItemLoading: boolean;
  setVideoSuiteHistoryItems: (data: VideoHistoryData[]) => void;
}

const VideoSuiteHistoryContainer = () => {
  const {
    VideoAppHistoryItems,
    DeleteVideoItem,
    isVideoHistoryLoading,
    isDeleteVideoItemLoading,
    setVideoSuiteHistoryItems,
  } = useOutletContext<ContextType>();
  const getUserCredits = useGetUserCredits();
  const { refetch: GetAllVideos , data: VideoHistoryData } = useGetVideoSuiteHistory();
  const [videoHistoryId, setVideoHistoryId] = useState<string>("");
  const [openVideoHistoryDetailsModal, setOpenVideoHistoryDetailsModal] =
    useState(false);

  const handleOpenVideoHistoryDetailsModal = (videoId: string) => {
    setVideoHistoryId(videoId);
    setOpenVideoHistoryDetailsModal(true);
    setIsFireRegenerate(false);
  };
  // to avoid call getVideos in close modal only when regenerate video
  const [isFireRegenerate, setIsFireRegenerate] = useState<boolean>(false);
  const handleCloseVideoHistoryDetailsModal = () => {
    setOpenVideoHistoryDetailsModal(false);
    if (isFireRegenerate) {
      GetAllVideos({});
      getUserCredits();
    }
  };

  useEffect(() => {
    if (VideoHistoryData) {
      setVideoSuiteHistoryItems(VideoHistoryData);
    }
  },[VideoHistoryData])

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {isVideoHistoryLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexGrow: 1,
          }}
        >
          <CircularProgress size={50} color="primary" />
        </Box>
      ) : VideoAppHistoryItems && VideoAppHistoryItems.length > 0 ? (
        <Box
          className="video-suite-history-container"
          sx={{
            placeItems: { xs: "center", sm: "flex-start" },
          }}
        >
          {VideoAppHistoryItems.map((video) => (
            <VideoSuiteHistoryCard
              key={video.id}
              videoData={video}
              handleOpenVideoHistoryDetailsModal={
                handleOpenVideoHistoryDetailsModal
              }
              isDeleteVideoHistoryLoading={isDeleteVideoItemLoading}
              DeleteVideoHistory={DeleteVideoItem}
            />
          ))}
          {openVideoHistoryDetailsModal && (
            <Modal
              open={openVideoHistoryDetailsModal}
              onClose={handleCloseVideoHistoryDetailsModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <VideoSuiteHistoryDetailsModal
                videoId={videoHistoryId}
                handleCloseModal={handleCloseVideoHistoryDetailsModal}
                setIsFireRegenerate={setIsFireRegenerate}
                btnActionText="Regenerate"
              />
            </Modal>
          )}
        </Box>
      ) : (
        <EmptySuiteHistory 
          suiteRouting="/suites/video-suite"
          suiteClass="empty-video-history-image"
          suiteHeader="No Videos found"
          suiteMessage="Explore all video apps and create the creative ones with Expertex.AI"
        />
      )}
    </Box>
  );
};

export default VideoSuiteHistoryContainer;
